const cinternoitems = {
/* ===== IMAGEN DE FONDO ===== */
  background:
    "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/MSCI_001.png",


    /* ===== ENCABEZADO CON ENLACES ===== */
  links: [
    { texto: "Inicio", url: "/Cinterno" },
    { texto: "Metodología", url: "/Cinterno/Metodologia" },
    { texto: "Componentes de Control", url: "/Cinterno/Control" },
    { texto: "Organigrama", url: "/Cinterno/Organigrama" },
    { texto: "Evidencias", url: "/Cinterno/Evidencias" }
  ],

  /* ===== CUADRO DE TEXTO ===== */
  cuadroTexto: {
    titulo: "Estructura del Trabajo",
    descripcion:
      "La Secretaría de Bienestar e Inclusión Social, para el cumplimiento de su mandato legal, misión, visión y objetivos institucionales y en apego a las disposiciones jurídicas aplicables implementa su Sistema de Control Interno Institucional."
  },

  /* ===== IMÁGENES ===== */
  imagenes: [
    {
      id: 1,
      src: "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/cinterno/pic1.jpg"
    },
    {
      id: 2,
      src: ""
    }
  ],

  /* ===== PDF VIEWER ===== */
  pdfViewer:
    ""

};

export default cinternoitems;